import { useEffect, useState } from 'react';
import { Box, Typography, Divider, Toolbar } from '@mui/material';
import { useNavigate } from 'react-router';

import { useUser } from '@/providers/UserContext';
import LoadingMask from '@/components/shared/LoadingMask';

import { useApi } from '@/providers/ApiContext';
import { getManifest } from '@/actions/manifest';
import AdminManifestChecks from '../AdminManifests/AdminManifest/AdminManifestChecks';
import type { Manifest } from '@/types';

function AdminGlobalChecks(): React.JSX.Element {
  const user = useUser();
  const api = useApi();
  const navigate = useNavigate();
  const [manifest, setManifest] = useState<Manifest | null>(null);
  const [loading_manifest, setLoadingManifest] = useState<boolean>(true);

  useEffect(() => {
    if (user?.entity_id && !manifest && api) {
      getManifest(api, 'global')
        .then((data) => {
          setManifest(data);
          setLoadingManifest(false);
        })
        .catch((error) => {
          console.log(error);
          setLoadingManifest(false);
          navigate('/error', {
            state: {
              errorMessage: 'Failed to load global checks',
              errorDetails:
                (error as Error).message ||
                'Unable to retrieve global document control checks. This could be due to network issues or server problems.',
              returnPath: '/admin/global',
            },
          });
        });
    }
  }, [api, user?.entity_id, manifest, navigate]);

  if (loading_manifest) {
    return <LoadingMask />;
  }

  return (
    <>
      <Toolbar
        sx={{
          minHeight: '55px !important',
        }}
      >
        <Typography variant='h6' sx={{ mr: 4 }}>
          Global Document Control Checks
        </Typography>
      </Toolbar>
      <Divider />

      <Box padding='15px'>
        <AdminManifestChecks manifest={manifest} global setEmpty={() => {}} />
      </Box>
    </>
  );
}

export default AdminGlobalChecks;
